/* unplugin-vue-components disabled */import script from "./EditProfileDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProfileDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditProfileDialog.vue?vue&type=style&index=0&id=bf3902d6&lang=scss"
import "./EditProfileDialog.vue?vue&type=style&index=1&id=bf3902d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf3902d6"]])

export default __exports__